var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizzesStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.224,
    height: 29.503,
    viewBox: "0 0 22.224 29.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 22.224,
    height: 29.503,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M63.846,451.452H46.173v-1.621c0-2.909,3.348-5.814,6.136-6.007.821-.056.544.107.982.542a2.522,2.522,0,0,0,3.405.031c.5-.468.175-.639,1.071-.566,2.774.228,6.079,3.1,6.079,6Z",
    transform: "translate(-43.898 -421.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M123.991,132.8l-6.172.015c-.3-.374-.714-.65-1.031-1.018a5.418,5.418,0,1,1,8.2,0c-.309.359-.733.631-1,1m-2.867-2.866c.169-.209.009-.574.114-.745.048-.08.553-.272.7-.381a2.005,2.005,0,0,0-2.316-3.27c-.552.364-1.425,1.892-.5,2.149.629.175.566-.607.714-.917a1,1,0,1,1,1.742.979c-.356.605-1.232.271-1.321.84a5.538,5.538,0,0,0,.029,1.234.539.539,0,0,0,.838.11m-.506.475c-.58.119-.442,1.133.224,1a.511.511,0,0,0-.224-1",
    transform: "translate(-109.777 -116.789)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M179.014,345.936c-.1.363-.037.727-.145,1.094a1.719,1.719,0,0,1-1.664,1.2,4.1,4.1,0,0,1-2.636-.421c-.579-.49-.546-1.185-.641-1.87Z",
    transform: "translate(-165.359 -328.894)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M199.428,410.393c.018,0,.072-.1.095-.064a1.457,1.457,0,1,1-2.8,0c.023-.032.081.064.095.064a23.428,23.428,0,0,0,2.606,0",
    transform: "translate(-187.013 -390.108)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M64.815,338.163c.507-.106.775.45.491.877a16.294,16.294,0,0,1-1.43,1.43c-.523.346-1.085-.11-.815-.625a20.643,20.643,0,0,1,1.516-1.535.6.6,0,0,1,.239-.147",
    transform: "translate(-59.887 -321.491)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M339.1,338.151a.464.464,0,0,1,.43.116,18.671,18.671,0,0,1,1.523,1.528c.324.51-.241,1.024-.789.662a16.31,16.31,0,0,1-1.43-1.43.545.545,0,0,1,.266-.876",
    transform: "translate(-322.033 -321.479)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M63.532,63.155a.54.54,0,0,1,.435.047c.381.519,1.218,1.056,1.554,1.56.31.465-.162.984-.71.71a14.521,14.521,0,0,1-1.451-1.409c-.229-.323-.3-.8.172-.908",
    transform: "translate(-60.068 -60.022)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M340.452,62.966c.544-.165.9.328.58.835a13.1,13.1,0,0,1-1.394,1.4c-.56.387-1.075.005-.847-.593.333-.236,1.387-1.563,1.661-1.646",
    transform: "translate(-322.048 -59.833)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M215.182.017a.5.5,0,0,1,.654.463,14.832,14.832,0,0,1,0,2.161.536.536,0,0,1-.982.1,17.28,17.28,0,0,1-.03-2.315.49.49,0,0,1,.36-.4",
    transform: "translate(-204.215 0)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M.349,214.986a17.109,17.109,0,0,1,2.337-.012c.493.093.453.92-.129,1.012a14.072,14.072,0,0,1-2.144-.01c-.507-.114-.569-.878-.063-.99",
    transform: "translate(0 -204.351)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M389.878,214.9c.687.067,1.749-.141,2.389,0,.52.115.445.911-.117,1a14.078,14.078,0,0,1-2.144-.01.53.53,0,0,1-.127-.991",
    transform: "translate(-370.393 -204.266)",
    fill: "#fa0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizzesStudent);
export default __webpack_public_path__ + "static/media/quizzes_student.12ef64976cb2e4df1bfffc87373a065c.svg";
export { ForwardRef as ReactComponent };